<!-- - RELAY-->
<div
  class="event-log-box"
  [id]="'log-box-' + log.id"
  [class.is-select]="log.isSelected"
  [class.is-warning]="parseWarningLog()"
  (mouseenter)="onHoverLog($event, log.id)"
  (mouseleave)="onMouseLeaveLog($event, log)"
>
  <div class="event-log-action-box">
    <div class="action-box relay-background">
      <comp-icon [icon]="relayIcon(log.meta)" [color]="'#FFC75F'" [size]="32"></comp-icon>
    </div>
  </div>
  <div class="event-log-metadata">
    <div class="flex" style="gap: 6px; flex-direction: column">
      <div class="v-center" style="gap: 8px; flex-wrap: wrap">
        <div class="event-log-metadata-time">{{ log.eventCreated }}</div>
        <div class="event-log-metadata-category flex v-center" style="gap: 8px; flex-wrap: wrap">
          <div class="badge relay-background">Manual Relay Event</div>
          <div class="badge automation" *ngIf="isAutomationRule(log)" style="margin-left: 4px">Automation Action</div>
          <div
            class="--g-tooltip-content"
            *ngIf="parseWarningLog()"
            (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
          >
            <comp-icon class="--g-tooltip-icon" [icon]="'info'" [size]="16" [color]="'rgb(205, 61, 100)'"></comp-icon>
            <div class="--g-tooltip" style="text-transform: none">
              This event includes data that could not be transmitted to the monitoring station.
            </div>
          </div>
        </div>
      </div>
      <div class="v-center" style="gap: 8px; flex-wrap: wrap">
        <ng-container *ngFor="let list of log.eventCodeList">
          <div
            class="--g-tooltip-content"
            (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
            style="margin: 0"
          >
            <div class="badge xml-code">{{ list.code }}</div>
            <div class="--g-tooltip tooltip-background">XML Code</div>
          </div>
        </ng-container>
      </div>
      <div class="event-log-metadata-device">
        <div class="event-log-metadata-device-name" [class.no-name]="!log.name">{{ log.name ?? "No Name" }}</div>
      </div>
      <div class="event-log-metadata-other">{{ capitalizeFirstLetter(log.status_text) }}</div>
      <div class="event-log-metadata-other" *ngIf="log?.partnerDescription">{{ log?.partnerDescription }}</div>
    </div>
    <div class="event-log-metadata-id">
      <span *ngIf="log?.event_id">ID {{ log.event_id }}</span>
      <span *ngIf="log?.partnerEventId"> | Partner ID {{ log.partnerEventId }}</span>
    </div>
    <!-- SLOT : toolbar-->
    <ng-container *ngTemplateOutlet="toolbar; context: { log: log }"></ng-container>
  </div>
</div>
